'use client'

import { IconX } from '@macarongfactory/web-icons'
import { TopNavigation } from '@macarongfactory/web-ui'

import { logEvent } from '@/shared/external/firebase/analytics'
import { CODE, EVENT_NAMES, TYPE } from '@/shared/lib'

import { closeCurrentTab } from '../../lib'

const CLOSE_BUTTON_LABEL = '닫기'

// 제휴 유입 전용 탑 네비게이션. 닫기 버튼만 있고, 클릭 동작은 CTA와 동일하게 탭을 닫는다 (WEB-5901)
const PlacePartnerTopNavigation = () => {
  const handleCloseClick = () => {
    logEvent(EVENT_NAMES.COMMON_WEB_PLACE.ITEM.CLICK, {
      code: CODE.COMMON_WEB_PLACE.CTA,
      type: TYPE.BUTTON,
      label: CLOSE_BUTTON_LABEL,
    })
    closeCurrentTab()
  }

  return (
    <div className='sticky top-0 z-20 w-full'>
      <TopNavigation
        trailing={
          <TopNavigation.Trailing.IconButton
            icon={<IconX width={24} height={24} />}
            clickable={handleCloseClick}
          />
        }
      />
    </div>
  )
}

export default PlacePartnerTopNavigation
